import { useState } from 'react'
import './RightHome.scss'
import InvestmentTransaction from './RightHomeComponents/InvestmentTransaction'
import ProbabilityMarket from './RightHomeComponents/ProbabilityMarket'
import Trend from './RightHomeComponents/Trend'

export default function RightHome() {
  const [tabActive, setTabActive] = useState('1')
  return (
    <>
      <div className='cgbhpebgmj'>
        <div className='qutvayvygx'>Thị Trường Việt Nam</div>
        <div className='bfkqcyujrd'>
          <div onClick={() => setTabActive('1')} className={`ihazsipjrc ${tabActive === '1' ? 'EnjeWUCiga' : ''}`}>Xu hướng dòng tiền</div>
          <div onClick={() => setTabActive('2')} className={`ihazsipjrc ${tabActive === '2' ? 'EnjeWUCiga' : ''}`}>Giao dịch ròng khối đầu tư</div>
          <div onClick={() => setTabActive('3')} className={`ihazsipjrc ${tabActive === '3' ? 'EnjeWUCiga' : ''}`}>Xác suất giao dịch thị trường</div>
        </div>

        <div className='nheppniyrc'>
          {tabActive === '1' ? <Trend /> : null}
          {tabActive === '2' ? <InvestmentTransaction /> : null}
          {tabActive === '3' ? <ProbabilityMarket /> : null}
        </div>
      </div>
    </>
  )
}